<template>
	<div class="form-image-field">
		<p v-if="saving">Uploading .........................</p>
		<input v-if="!isUploaded && !saving" :id="id" type="file" ref="file" @change="handleImageUpload" />
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'FormFileField',
  props: [
    'id'
  ],
  data () {
    return {
      file: '',
      saving: false,
      uploaded: {}
    }
  },
  computed: {
    isUploaded () {
      return this.uploaded.url !== undefined
    }
  },
  methods: {
    handleImageUpload () {
      this.file = this.$refs.file.files[0]
      if (this.file.size && (this.file.size / 1024 / 1024) > 8) {
        alert('The image size is too big. Please upload image less than 8 MB')
        return
      }
      const formData = new FormData()
      formData.append('file', this.file)
      Vue.api.post('/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: (response) => {
          this.uploaded = response
          this.uploaded.fieldId = this.id
          this.$emit('uploadedFile', this.uploaded)
        }
      })
    }
  }
}
</script>

<style scoped>
	.form-image-field img {
		width: 150px;
	}
</style>
